/**
 * Packaging OS — frontend entry point (Phase 1N-B / 1O-A / 1P-A).
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "./styles/base.css";
import "./styles/layout.css";
import "./styles/studio-polish.css";
import { App } from "./app/App";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Packaging OS shell: #root element not found in index.html");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
